import { Injectable } from '@angular/core'
import { APIService } from '../services/api.service'
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable()
export class UserServices {
    httpOptions: any = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        })
    }
    constructor(private _http: HttpClient, private _apiServices: APIService) { }
    savePatients(employee) {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        let data = employee;
        let body = JSON.stringify(data);
        return this._http.post(environment.apiURL + "/api/createUser", body, this.httpOptions)
            .catch(this.handleError);
    }

    getFAQ() {
        this.httpOptions.headers.append('Content-Type', 'application/form-data');
        this.httpOptions.headers.append('Content-Type', 'multipart/form-data');
        var loginUser = JSON.parse(localStorage.getItem('currentUser'));
        let body = {}
        return this._http.post(environment.apiURL + "/api/getFaq", body, this.httpOptions)
            .catch(this.handleError);
    }


    handleError(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/userservices.service.ts